import React from 'react';
import { DisplayInputComponentProps } from '../../types';
import type { FieldValues } from 'react-hook-form';
import { WidgetOption } from '../../displayer.utils';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';

type CheckboxConfig = {
    checkboxMode: 'radio' | 'checkbox' | 'toggle';
    direction?: 'row' | 'column' | 'two-columns';
    requireable?: boolean;
};

export const InputCheckbox =
    (options: WidgetOption[], config: CheckboxConfig) =>
    // eslint-disable-next-line react/display-name
    <TFieldValues extends FieldValues>({ widget: _, ...props }: DisplayInputComponentProps<TFieldValues>) => {
        const InputCheckbox = commonComponentsRegistry.getLazyComponent('InputCheckbox');

        if (!('direction' in config)) config.direction = options.length > 3 ? 'column' : 'row';
        if (!('requireable' in config)) config.requireable = true;

        const required = config.requireable && props.mandatory;

        // {/* TODO multiple */}
        return (
            <>
                <InputCheckbox
                    {...props}
                    label={config.checkboxMode === 'toggle' ? '' : props.label}
                    checkboxMode={config.checkboxMode}
                    options={options}
                    direction={config.direction}
                    rules={{ required }}
                    margin={props.margin}
                    valueTypeIsBoolean={config.checkboxMode === 'toggle'}
                />
            </>
        );
    };
